import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import { useNotification } from '@iziping/ui';
import {useQueryClient} from "@tanstack/react-query";
import {type FinishMatchParams, useFinishMatch, useGetMatch, useModifyMatchResults} from "./matchesHooks";
import type {HeatRegistration} from '@iziping/common';
import { QUERY_CACHE } from '@/model/endpoints';
import "./match.css"
import SortableList from "../shared/sort/SortableList";
import SortableRow from "../shared/sort/SortableRow";
import PlayerItem from "../shared/sort/PlayerItem";
import {computeQualified, displayRound} from '@iziping/common';

interface FinishMatchProps {
    id: number;
    onSuccess: () => void;
}

const FinishMatch: React.FC<FinishMatchProps> = ({id, onSuccess}) => {
    const {t} = useTranslation();
    const {notify} = useNotification();
    const queryClient = useQueryClient();
    const {data: match, isLoading, isError} = useGetMatch(id);
    const modifyMatch = useModifyMatchResults();

    const [orderedPlayers, setOrderedPlayers] = useState<HeatRegistration[]>([]);
    useEffect(() => {
        if (match?.opponents) {
            setOrderedPlayers(match.opponents);
        }
    }, [match]);


    const handleModifyMatch = async () => {
        try {
            const payload: FinishMatchParams = {
                matchId: id,
                opponents: orderedPlayers // orderedPlayers doit être de type HeatRegistration[]
            };

            await modifyMatch.mutateAsync(payload);
            await queryClient.invalidateQueries({queryKey: [QUERY_CACHE.MATCHES_SEARCH_FINISHED]});
            onSuccess();
            notify(t('match.notif.finish.success'), 'success');
        } catch (error: any) {
            notify(t(error.error), 'error');
        }
    };

    return (
        match &&
        <div>
            <div className="modalTitle">
                <div className="heatName">Série {match.heatName}</div>
                <div className="matchName">{displayRound(match)}</div>
                <SortableList
                    items={orderedPlayers}
                    setItems={setOrderedPlayers}
                    idKey="id"
                    renderItem={(player, index) => (
                        <SortableRow key={player.id} id={player.id}>
                            <PlayerItem player={player} index={index} qualifiedCount={computeQualified(match)}/>
                        </SortableRow>
                    )}
                />
            </div>
            <div className="actions">
                <button className="button" onClick={handleModifyMatch}>Modifier les résultats</button>
            </div>
        </div>
    )
}

export default FinishMatch;